import { render, staticRenderFns } from "./MissionDetailGender.vue?vue&type=template&id=0a8fdd78&scoped=true&"
import script from "./MissionDetailGender.vue?vue&type=script&lang=js&"
export * from "./MissionDetailGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8fdd78",
  null
  
)

export default component.exports